<template>
  <v-app data-app>
    <v-overlay :value="showLoading" :z-index="9999">
      <div style="display: flex; flex-flow: column">
        <v-icon :size="70">$galaposG</v-icon>
        <v-progress-circular :size="110" style="position: absolute; top: -22px; left: -15px" :width="6" color="#FFC107"
          indeterminate></v-progress-circular>
      </div>
    </v-overlay>
    <notifications position="bottom left" group="geral" />
    <!-- <div v-if="version" class="version">{{ version }}</div> -->

    <terms-of-use-modal></terms-of-use-modal>
    <GlobalHelpDialog />

    <router-view v-if="!authed" name="public"></router-view>
    <template v-else>
      <kore-context v-if="context" :data.sync="context"></kore-context>
      <WebSocketNotifications />

      <kore-modal
        :value="!!alert"
        :title="alert.title"
        @closeAll="closeAll()"
        @confirm="alertConfirm()"
        @cancel="doCancel()"
      >
        <div v-html="alert.msg"></div>
      </kore-modal>

      <kore-side :me="authed.data" :colapse="colapse" @colapse="doColapse()"></kore-side>
      <div class="main-body vertical-default" :class="{ 'side-colapse': colapse }">
        <kore-nav :user="$store.getters.jwtData.data"></kore-nav>
        <v-tabs mandatory class="openedTabs" active-class="tab-ativa" slider-size="0" height="28px">
          <v-tab
            :style="{
              'background-color': currentTab.meta.color
            }"
            :to="{ path: currentTab.fullPath }"
            target="_blank"
            exact
          >
            {{ currentTab.meta.pageTitle || currentTab.meta.name }}
            <v-icon class="mr-n2" small right>mdi-open-in-new</v-icon>
          </v-tab>
        </v-tabs>

        <div class="md-flex route-container">
          <router-view :key="$route.fullPath"></router-view>
          <kore-chat v-if="false" :token="token" :myId="user.id"></kore-chat>
        </div>
      </div>
    </template>
  </v-app>
</template>

<script>
import Vue from "vue";
import VueRouter from "vue-router";
import Vuex, { mapActions, mapGetters } from "vuex";
import VueTheMask from "vue-the-mask";

import moment from "moment";
import "moment/locale/pt-br";

import { cloneDeep, debounce, forEach, isEmpty, isObject, remove, sortBy } from "lodash";

import momentDurationFormatSetup from "moment-duration-format";

import Notifications from "vue-notification";

import mixins from "./mixins.vue";

import routes from "./routes.js";
import { ValidationProvider, extend } from "vee-validate";
import VueJwtDecode from "vue-jwt-decode";

import { BeneficiosEnum } from '@/core/enums/beneficios.js';
import { UserTypeEnum } from '@/core/enums/user-types';
import SocketIOPlugin from '@/plugins/socket.io.js';
import getValidDatesTuple from '@/helpers/getValidDatesTuple.js';
import { userHasAccess } from '@/helpers/permissionValidator';
import { formatCNPJ, formatCPF } from '@/helpers/masks';
import apiResource from '@/helpers/fetch';
import projetosEnquadradosLeiInformatica from "./store/projetos/projetosEnquadradosLeiInformatica";
import projetosComentarios from "./store/projetos/comentarios";
import { setRoot } from '@/api/api';

momentDurationFormatSetup(moment);

// Previne globalmente console errors vindos do bloqueio de navegação de algum navegate guard
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }

  return originalPush.call(this, location).catch((err) => {
    if (VueRouter.isNavigationFailure(err, VueRouter.NavigationFailureType.aborted)) {
      console.warn(`A navegação para ${location.name} foi interrompida por um Navigation Guard.`);
      return err
    }

    // rethrow error
    return Promise.reject(err)
  })
}

Vue.filter("toCurrency", function (value) {
  if (isNaN(value)) {
    return value;
  }
  var formatter = new Intl.NumberFormat("pt-BR", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return "R$ " + formatter.format(value);
});

Vue.filter("toCurrencyValue", function (value) {
  if (isNaN(value)) {
    return value;
  }
  var formatter = new Intl.NumberFormat("pt-BR", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formatter.format(value);
});

Vue.filter("toNumber", function (value) {
  if (isNaN(value)) {
    return value;
  }
  var formatter = new Intl.NumberFormat("pt-BR", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  return formatter.format(value);
});

Vue.filter("toDouble", function (value) {
  if (value) {
    let array = value.toString().split(",");
    let newValue = array.join("");
    value = newValue;
  }

  if (isNaN(value)) {
    return value;
  }

  let formatter = new Intl.NumberFormat("pt-BR", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  });

  return formatter.format(value);
});

Vue.filter("toDoubleComplete", function (value) {
  if (value) {
    let array = value.toString().split(",");
    let newValue = array.join("");
    value = newValue;
  }

  if (isNaN(value)) {
    return value;
  }

  let formatter = new Intl.NumberFormat("pt-BR", {
    style: "decimal",
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  });

  return formatter.format(value);
});

var getMomentDate = (value) => {
  moment.locale("pt-br");
  var dateMoment = moment(value, "DD/MM/YYYY HH:mm", true);
  return dateMoment.isValid() ? dateMoment : moment(value);
};

Vue.filter("toDate", function (value) {
  if (!value) return value;
  var dateMoment = getMomentDate(value);
  return dateMoment.isValid() ? dateMoment.format("L") : value;
});

Vue.filter("toDateTime", function (value) {
  if (!value) return value;
  var dateMoment = getMomentDate(value);
  return dateMoment.isValid() ? dateMoment.format("DD/MM/YYYY HH:mm") : value;
});

Vue.filter("toOnlyTime", function (value) {
  if (!value) return value;
  var dateMoment = getMomentDate(value);
  return dateMoment.isValid() ? dateMoment.format("HH:mm") : value;
});

Vue.filter("toTimeAndSeconds", function (value) {
  if (!value) return value;
  var dateMoment = getMomentDate(value);
  return dateMoment.isValid() ? dateMoment.format("HH:mm:ss") : value;
});

Vue.filter("toMonth", function (value) {
  if (!value) return value;
  var dateMoment = getMomentDate(value);
  return dateMoment.isValid() ? dateMoment.format("MM/YYYY") : value;
});

Vue.filter("toFullMonth", function (value) {
  if (!value) return value;
  var dateMoment = getMomentDate(value);
  var result = dateMoment.isValid()
    ? dateMoment.format("MMM [de] YYYY")
    : value;
  return result[0].toUpperCase() + result.slice(1);
});

Vue.filter("toFromNow", function (value) {
  if (!value) return value;
  var dateMoment = getMomentDate(value);
  return dateMoment.isValid() ? dateMoment.fromNow(true) : value;
});

Vue.filter("toDaysLeft", function (value) {
  if (!value) {
    return value;
  }

  const deadline = getMomentDate(value);
  const today = moment();
  const daysLeft = deadline.diff(today, 'days');

  if (!daysLeft) {
    return "Hoje";
  }

  return daysLeft;
});

Vue.filter("toDuration", function (value) {
  if (!value) return value;
  return moment.duration(value).humanize();
});

Vue.filter("toDiasUteis", function (value) {
  if (!value) return value;
  return `(${Math.round(moment.duration(value).asDays())} dias úteis.)`; //humanize();
});

Vue.filter("toCalendar", function (value) {
  if (!value) return value;
  var dateMoment = getMomentDate(value);
  return dateMoment.isValid() ? dateMoment.calendar() : value;
});

Vue.filter("toWeekDay", function (value) {
  if (!value) return value;
  var dateMoment = getMomentDate(value);

  var result = dateMoment.isValid() ? dateMoment.format("ddd DD MMM") : value;
  result = result
    .split(" ")
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(" ");

  return result;
});

var formatPeriod = function (period, format) {
  period = sortBy(period);
  moment.locale("pt-br");
  var ini = moment(period[0]);
  var result = ini.isValid() ? ini.format(format) : period[0];
  if (period[1]) {
    var end = moment(period[1]);
    result += ` a ${end.isValid() ? end.format(format) : period[1]}`;
  }
  return result;
};

Vue.filter("toPeriod", function (period) {
  if (!period) return period;
  const format = "D [de] MMM [de] YYYY";
  return formatPeriod(period, format);
});

Vue.filter("toMonthPeriod", function (period) {
  if (!period) return period;
  return formatPeriod(period, "MMM [de] YYYY");
});

Vue.filter("toTime", function (value) {
  if (isNaN(value)) {
    return value;
  }
  return moment.duration(value, "hours").format("hh:mm", {
    trim: false,
  });
});

Vue.filter("toCNPJ", function (value) {
  return formatCNPJ(value);
});

Vue.filter("toCPF", function (value) {
  return formatCPF(value);
});

extend("email", {
  validate: (v) => {
    var re = /\S+@\S+\.\S+/;
    return v && re.test(v);
  },
  message: "Digite um e-mail válido",
});

extend("min", {
  validate: (v, { min }) => {
    return v && v.length >= min;
  },
  params: ["min"],
  message: "Senha inválida!",
});

extend("nome", {
  validate: (v) => {
    var nome = v.split(" ");

    return nome.length > 1;
  },
  message: "Digite um nome e sobrenome",
});

extend("validate", {
  validate: (v, { pass }) => {
    return v === pass;
  },
  params: ["pass"],
  message: "A senha digitada não coincide",
});

extend("required", {
  validate: (value) => {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  computesRequired: true,
  message: "Este campo é obrigatório",
});

Vue.component("ValidationProvider", ValidationProvider);
Vue.mixin(mixins);
Vue.use(Vuex);
Vue.use(VueTheMask);
Vue.use(Notifications);
Vue.use(VueRouter);

Vue.use(SocketIOPlugin, {
  connection: process.env.VUE_APP_SOCKET_URL
});

Vue.use({
  install(Vue) {
    Vue.prototype.$fieldTypes = {
      TEXT: "text",
      TEXTAREA: "textarea",
      AUTOCOMPLETE: "autocomplete",
      AUTOCOMPLETE_MULTIPLE: "autocomplete_multiple",
      SELECT: "select",
      RADIO: "radio",
      NUMBER: "number",
      DOUBLE: "double",
      MONEY: "money",
      MONEY2: "money2",
      MONEY3: "money3",
      DATETIME: "datetime",
      DATE: "date",
      MONTH: "month",
      FROMNOW: "fromnow",
      DAYSLEFT: "daysleft",
      DURATION: "durarion",
      PASSWORD: "password",
      TIME: "time",
      BIGTIME: "bigtime",
      HTML: "html",
      CHECKBOXES: "checkboxes",
      COMBOBOX: "combobox",
      SWITCH: "switch",
      FILE: "file",
      FILE2: "g-file-picker", // TODO no futuro esse campo vai virar o único FILE do sistema
      SUBTITLE: "subtitle",
      CPF: "cpf",
      CNPJ: "cnpj",
      TELEPHONE: "telephone",
      DOWNLOAD: "download",
      TEXT_CHIP: "text_chip",
      RICHTEXT: "richtext",
    };
    /* "#E5CB5E", "#EF8065", "#EF4848", "#BC3588", "#25935F", "#10777E", "#96D4E6", "#6C92C5", "#3C4196", "#28A1B5", "#4FC690" */
    Vue.prototype.$chartColors = [
      "#E5CB5E",
      "#EF8065",
      "#EF4848",
      "#BC3588",
      "#25935F",
      "#10777E",
      "#96D4E6",
      "#6C92C5",
      "#3C4196",
      "#28A1B5",
      "#4FC690",
    ];
    Vue.prototype.$userDefaultImgBase64 =
      "data:image/png;base64,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";
  },
});

const LOCAL_STORAGE_KEY = 'teros:vuex';

/**
 * @typedef {import('./core/types/jsdoc').Empresa} Empresa
 * @typedef {import('./core/types/jsdoc').JWTToken} JWTToken
 * @typedef {import('./core/types/jsdoc').User} User
 * 
 * @typedef {Object} FiltrosGlobais
 * @property {string} anoBase
 * @property {[string, string]} intervaloCompetencia
 * @property {[string, string]} intervaloData
 * @property {number} servico
 * 
 * @typedef {Object.<string, number|string|boolean|string[]>} FiltrosColunas
 * @typedef {Object.<string, ('asc'|'desc')>} OrdenacaoColunas
 * @typedef {Object} EstadoPagina
 * @property {FiltrosColunas} filters
 * @property {OrdenacaoColunas} sort
 * @typedef {Object.<string, EstadoPagina>} FiltrosPorPagina
 * 
 * @typedef {Object} Paginacao
 * @property {(-1|10|50|200)} itemsPerPage
 * 
 * @typedef {Object} Notification
 * @property {number} id
 * @property {string} message
 * @property {boolean} read
 * 
 * @typedef {Object} NotificationState
 * @property {Notification[]} notifications
 * @property {number} unreadCount
 * @property {number} page
 * @property {number} lastPage
 * @property {string} criado_em
 */

/**
 * @typedef {Object} TerosState
 * @property {boolean} aceitouTermosUso
 * @property {string} activePage
 * @property {string} fromPage
 * @property {boolean} cannotAccessMessage
 * @property {number} clientId
 * @property {(1|2|3|4)} clientServico
 * @property {Empresa[]} clients
 * @property {FiltrosGlobais} filtros
 * @property {JWTToken|false} isAuthed
 * @property {FiltrosPorPagina} pages
 * @property {Paginacao} pagination
 * @property {?Empresa} selectedClient
 * @property {?User} user
 * @property {NotificationState} notification
 */

/** @type {TerosState} */
const VUEX_INITIAL_STATE = {
  aceitouTermosUso: false,
  activePage: '',
  fromPage: 'homepage', // Isso é o nome de uma página do sistema
  cannotAccessMessage: false,
  clients: [],
  filtros: {
    anoBase: moment().format('YYYY'),
    intervaloCompetencia: [
      moment().startOf('quarter').format('YYYY-MM'),
      moment().endOf('quarter').format('YYYY-MM'),
    ],
    intervaloData: [
      moment().startOf('week').format('YYYY-MM-DD'),
      moment().endOf('week').format('YYYY-MM-DD'),
    ],
    servico: BeneficiosEnum.LEI_DO_BEM,    
    trimestre: [1, 1],
  },
  isAuthed: false,
  pages: {},
  pagination: {
    itemsPerPage: 10,
  },
  selectedClient: null,
  user: null,
  uploadedFile: null,
  notification: {
    lastPage: 1,
    notifications: [],
    page: 1,
    unreadCount: 0,
  },
};

/**
 * @param {[string, string]} intervalo
 * @return {[string, string]}
 */
const updateIntervalsYear = (intervalo, format = 'YYYY-MM', year = 0) => {
  const [ini, fim] = intervalo.map((date) => moment(date, format));
  const difference = fim.get('year') - ini.get('year');
  ini.set('year', year);
  fim.set('year', year + difference);
  return [ini, fim].map(date => date.format(format));
}

const store = new Vuex.Store({
  state: VUEX_INITIAL_STATE,
  modules: {
    projetosLi: projetosEnquadradosLeiInformatica,
    projetos: projetosComentarios
  },
  actions: {
    getClientsList: async function ({ commit, getters }, corporacao_id) {
      if (!getters.jwtToken) {
        return null;
      }

      const query = corporacao_id ? `?corporacao_id=${corporacao_id}` : '';
      const url = `${process.env.VUE_APP_API_URL}/v1/clientes${query}`;

      try {
        const response = await fetch(url, {
          headers: {
            'X-Auth-Token': getters.jwtToken,
          }
        });
        const data = await response.json();
  
        if (data.error) {
          throw data;
        }

        const list = Array.isArray(data) ? data : [data];
        commit('setClients', list);
        return list;
      } catch (e) {
        return [];
      }
    },
    getUserData: async function ({ commit, getters, state }, force = false) {
      if (!force && !!state.user) {
        return getters.user;
      }

      if (!getters.jwtToken) {
        return null;
      }

      const query = getters.clientId ? `?empresaId=${getters.clientId}` : '';
      const url = `${process.env.VUE_APP_API_URL}/v1/authorization/me${query}`;

      try {
        const response = await fetch(url, {
          headers: {
            'X-Auth-Token': getters.jwtToken,
          }
        });
        let { code, error, ...user } = await response.json();
  
        if (error) {
          throw { code, error };
        }

        // TODO descontinuar suporte ao linkData quando o back deixar de dar suporte
        // Retrocompatibilidade com linkData
        if (user.link_data && !isEmpty(user.link_data)) {
          forEach(user.link_data, (value, key) => {
            if (!(key in user)) {
              user[key] = value;
            }
          });
        }

        commit("setUser", user);
        return user;
      } catch (e) {
        return null;
      }
    },
    setTrimestre: function ({ commit }, value) {
      commit('setTrimestreValue', value)
    },
    async getNotifications({ commit, getters, state }) {
      const notificationResource = apiResource("/v1/authorization/notificacoes", {
        headers: {
          'X-Auth-Token': getters.jwtToken,
        },
      });
      const response = await notificationResource.get({
        query: {
          page: state.notification.lastPage,
          per_page: 200,
        },
      });

      if (Array.isArray(response.data)) {
        commit("pushNotifications", response.data);
      }

      if (response.meta) {
        commit("setUnreadCount", response.meta.notifications_unread_count ?? 0);
        commit("setLastPage", response.meta.lastPage ?? 1);
      }
    },
    async markNotificationAsRead({ commit, getters, state }, id) {
      const notifications = [...state.notification.notifications];
      const found = notifications.find((note) => note.id === id);

      if (!found || found.read) {
        return;
      }

      const notificationResource = apiResource(`/v1/authorization/notificacoes/${id}`, {
        headers: {
          'X-Auth-Token': getters.jwtToken,
        },
      });
      const response = await notificationResource.post();
      const index = notifications.indexOf(found);

      if (index >= 0) {
        notifications.splice(index, 1, response);
        commit("setNotifications", notifications);
        commit("decrementUnreadCount");
      }
    },
  },
  getters: {
    getClientSidePaginationItemsPerPage(state) {
      return state.pagination.itemsPerPage;
    },
    getServerSidePaginationItemsPerPage(state) {
      const itemsPerPage = state.pagination.itemsPerPage;
      return itemsPerPage > 0 ? itemsPerPage : 200;
    },
    clientServico: (state) => {
      return state.selectedClient?.trabalho || BeneficiosEnum.LEI_DO_BEM_E_INFORMATICA;
    },
    clientId: (state) => {
      return state.selectedClient?.id || 0;
    },
    clients: (state) => {
      return state.clients;
    },
    user: (state) => {
      return state.user ? cloneDeep(state.user) : {};
    },
    foto: (state) => {
      return state.user ? state.user.foto : "";
    },
    jwtToken: (state) => {
      if (state.isAuthed?.token) {
        var token = VueJwtDecode.decode(state.isAuthed.token);
        if (token.exp > new Date().getTime() / 1000) {
          return state.isAuthed.token;
        } else {
        return false;
      }
      } else {
        return false;
      }
    },
    jwtData: (state) => {
      if (state.isAuthed?.token) {
        var token = VueJwtDecode.decode(state.isAuthed.token);
        if (token.exp > new Date().getTime() / 1000) {
          return token;
        } else {
        return false;
      }
      } else {
        return false;
      }
    },
    anoBase: (state) => state.filtros.anoBase,
    intervaloCompetencia: (state) => state.filtros.intervaloCompetencia,
    intervaloData: (state) => state.filtros.intervaloData,
    selectedClient: (state) => state.selectedClient || { id: 0, fantasia: 'nenhum' },
    cannotAccessMessage: (state) => state.cannotAccessMessage,
    aceitouTermosUso: (state) => state.isAuthed?.termoUso || false,
    getUserType: (state, getters) => getters.jwtData?.data?.tipo,
    userIsAdmin: (state, getters) => getters.getUserType == UserTypeEnum.ADMINISTRADOR,
    pageTableFilters: (state) => state.pages[state.activePage]?.filters || {},
    pageTableSort: (state) => state.pages[state.activePage]?.sort || {},
    getUserPermissions: (state) => state.user?.permissions,
    servico: (state) => state.filtros.servico,
    getUserCorporacaoId: (state) => state.user?.corporacao_id || null,
    uploadedFile: (state) => state.uploadedFile || null,
    trimestre: (state) => state.filtros.trimestre || null,
    fromPage: (state) => state.fromPage || 'homepage',
  },
  mutations: {
    initializeStore(state) {
      const ls = window.localStorage.getItem(LOCAL_STORAGE_KEY);
      const oldStore = ls ? JSON.parse(ls) : {};
      const aceitouTermosUso = state.isAuthed?.termoUso || oldStore.isAuthed?.termoUso || false;
      this.replaceState(Object.assign(state, {
        ...state,
        ...oldStore,
        aceitouTermosUso,
      }));
    },
    logout(state) {
      state.activePage = '';
      state.user = null;
      state.isAuthed = false;
      state.selectedClient = null;
    },
    setPaginationItemsPerPage(state, items) {
      const itemsPerPage = typeof items === 'string' ? parseInt(items) : items;
      if (Number.isSafeInteger(itemsPerPage)) {
        state.pagination = {
          ...state.pagination,
          itemsPerPage,
        }
      }
    },
    cannotAccessMessage(state, value) {
      state.cannotAccessMessage = value;
    },
    setClient(state, clientId) {
      if (isNaN(clientId)) {
        return;
      }

      const client = state.clients.find(({ id }) => clientId === id);      
      state.selectedClient = client;

      if ([BeneficiosEnum.LEI_DO_BEM, BeneficiosEnum.LEI_DE_INFORMATICA, BeneficiosEnum.CAPTACAO].includes(client?.trabalho)) {
        state.filtros = {
          ...state.filtros,
          servico: client.trabalho,
        }
      } else if (client?.trabalho === BeneficiosEnum.LEI_DO_BEM_E_INFORMATICA) {
        const servico = typeof state.filtros?.servico === 'number' && state.filtros.servico !== BeneficiosEnum.CAPTACAO ? state.filtros.servico : BeneficiosEnum.LEI_DO_BEM;
        state.filtros = {
          ...state.filtros,
          servico,
        };
      }
    },
    setClients(state, list) {
      if (list) {
        state.clients = Array.isArray(list) ? list : [list];
      } else {
        state.clients = [];
      }
    },
    setAceitouTermosUso(state, aceitouTermosUso) {
      if (typeof aceitouTermosUso === 'boolean') {
        state.aceitouTermosUso = aceitouTermosUso;
        window.localStorage.setItem("aceitouTermosUso", aceitouTermosUso);
      }
    },
    updateAuth(state, isAuthed) {
      if (isObject(isAuthed) && !isEmpty(isAuthed)) {
        window.localStorage.setItem("teros", JSON.stringify(isAuthed));
        if (isAuthed.trabalho && isAuthed.trabalho != 0) {
          state.clientServico = isAuthed.trabalho;
          window.localStorage.setItem("clientServico", isAuthed.trabalho);
        } else {
          state.clientServico = 3;
          window.localStorage.setItem("clientServico", 3);
        }
        state.isAuthed = isAuthed;
      } else {
        window.localStorage.removeItem("teros");
        window.localStorage.removeItem("clientServico");
        state.isAuthed = false;
        state.clientServico = 3;
      }
    },
    setAnoBase(state, ano) {
      const oldValue = Number.parseInt(state.filtros.anoBase);
      const parsedAno = typeof ano === 'string' ? Number.parseInt(ano) : ano;
      
      if (Number.isSafeInteger(parsedAno) && parsedAno !== oldValue) {
        const { intervaloCompetencia, intervaloData } = state.filtros;
        const [cIni, cFim] = updateIntervalsYear(intervaloCompetencia, 'YYYY-MM', parsedAno);
        const [dIni, dFim] = updateIntervalsYear(intervaloData, 'YYYY-MM-DD', parsedAno);
        
        state.filtros = {
          ...state.filtros,
          intervaloCompetencia: [cIni, cFim],
          intervaloData: [dIni, dFim],
          anoBase: `${parsedAno}`,
        };
      }
    },
    setIntervaloCompetencia(state, payload) {
      const intervalo = getValidDatesTuple(payload, 'YYYY-MM');
      const [ini, fim] = intervalo;
      const [oldIni, oldFim] = state.filtros.intervaloCompetencia;
      const isDiff = ini !== oldIni || fim !== oldFim;

      if (ini && fim && isDiff) {
        const anoBase = ini.replace(/(-\d\d)/g, '');
        
        state.filtros = {
          ...state.filtros,
          intervaloCompetencia: intervalo,
          anoBase,
        };
      }
    },
    setIntervaloData(state, payload) {
      const intervalo = getValidDatesTuple(payload, 'YYYY-MM-DD');
      const [ini, fim] = intervalo;
      const [oldIni, oldFim] = state.filtros.intervaloData;
      const isDiff = ini !== oldIni || fim !== oldFim;
      
      if (ini && fim && isDiff) {
        const anoBase = ini.replace(/(-\d\d-\d\d)/g, '');
        
        state.filtros = {
          ...state.filtros,
          intervaloData: intervalo,
          anoBase,
        };
      }
    },
    updateTermoUso(state, aceite) {
      if (typeof aceite === 'boolean') {
        state.isAuthed = {
          ...state.isAuthed,
          termoUso: aceite,
        }
        window.localStorage.setItem("teros", JSON.stringify(state.isAuthed)); // TODO isso vai ser apagado ao fazer merge com Melhorias em Filtros
      }
    },
    setActivePage(state, name) {
      // TODO quando cada rota tiver um name e for usado envez de path, posso remover esse parsed
      const parsed = name
        .replace(/\/clientes\/\d+/g, '')
        .replace(/^\//g, '')
        .replace(/\//g, '-');
      state.activePage = parsed;
    },
    setPageTableFilters(state, filters) {
      const pageData = state.pages[state.activePage] || {};
      state.pages[state.activePage] = {
        ...pageData,
        filters,
      };
    },
    setPageTableSort(state, sort) {
      const pageData = state.pages[state.activePage] || {};
      state.pages[state.activePage] = {
        ...pageData,
        sort,
      };
    },
    setServico(state, servico) {
      if ([BeneficiosEnum.LEI_DO_BEM, BeneficiosEnum.LEI_DE_INFORMATICA, BeneficiosEnum.CAPTACAO, BeneficiosEnum.ICT].includes(servico)) {
        state.filtros = {
          ...state.filtros,
          servico,
        }
      }
    },
    setUser(state, me) {
      let user = state.user || {};
      state.user = {
        ...user,
        ...me,
      };
    },
    setUploadedFile(state, value) {
      state.uploadedFile = value;            
    },
    setTrimestreValue(state, trimestre) {   
      state.filtros = {
        ...state.filtros,
        trimestre,
      }
    },
    setFromPage(state, value) {
      state.fromPage = value ?? 'homepage';
    },
    pushNotifications(state, values) {
      if (!Array.isArray(values)) {
        return;
      }

      state.notification.notifications.push(...values);
    },
    unshiftNotifications(state, values) {
      if (!Array.isArray(values)) {
        return;
      }

      state.notification.notifications.unshift(...values);
    },
    setNotifications(state, values) {
      if (!Array.isArray(values)) {
        return;
      }

      state.notification.notifications = values;
    },
    setLastPage(state, lastPage) {
      if (typeof lastPage !== 'number' || lastPage < 0) {
        return;
      }

      state.notification.lastPage = lastPage;
    },
    incrementPage(state) {
      state.notification.lastPage++;
    },
    decrementUnreadCount(state) {
      if (state.notification.unreadCount > 0) {
        state.notification.unreadCount--;
      }
    },
    incrementUnreadCount(state) {
      state.notification.unreadCount++;
    },
    setUnreadCount(state, value) {
      if (Number.isNaN(value)) {
        return;
      }

      state.notification.unreadCount = value;
    },
    resetNotification(state) {
      state.notification = {
        lastPage: 1,
        notifications: [],
        page: 1,
        unreadCount: 0,
      };
    },
  },
});

// Compatibilidade com antiga forma de salvar token no localStorage
const teros = localStorage.getItem('teros');

if (teros) {
  store.commit('updateAuth', JSON.parse(teros));
}
// Fim da compatibilidade com antiga forma de salvar token no localStorage    

// Inicialização da Vuex Store
store.commit("initializeStore");
const DEBOUNCE_TIME = 500; // em milisegundos
const SKIP_SAVE = ['clients', 'fromPage', 'notification', 'user'];
const subscribeFn = (_mutation, state) => {
  const safeStorage = Object.entries(state).reduce((prev, [key, value]) => {
    if (SKIP_SAVE.includes(key)) {
      return prev;
    }
    return { ...prev, [key]: cloneDeep(value) };
  }, {});
  window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(safeStorage));
};
const debounceFn = debounce(subscribeFn, DEBOUNCE_TIME);
store.subscribe(debounceFn);

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach(async (to, from, next) => {
  store.commit('setFromPage', from.name);
  store.commit('setActivePage', to.name || to.path);
  // Need to avoid losing query when paste URL in a new tab
  const destiny = (to.path === from.path && !!from.query) ? { ...to, query: from.query } : undefined;
  const userIsLogged = await store.dispatch("getUserData");  
  
  if (to.name === "login") {
    if (userIsLogged) {
      next({ name: "homepage" });
    } else {
      next();
    }
  } else if (to.meta?.public) {
    if(to.matched[0].path.includes('/recuperar-senha/') && userIsLogged) {
      store.commit('logout');
    }
    next(destiny);
  } else if (!userIsLogged) {
    store.commit('logout');
    next({
      name: "login",
      query: { redirect: to.name !== 'homepage' ? to.fullPath : undefined },
    });
  } else if (to.meta?.permissions && !userHasAccess(store.getters.user, to.meta.permissions)) {
    store.commit('cannotAccessMessage', true);
    next({ name: 'homepage' });
  } else {
    next(destiny);
  }
});

export default {
  name: "App",
  store,
  router,
  components: {
    "kore-side": () => import("./components/sidebar.vue"),
    "kore-nav": () => import("./components/navbar.vue"),
    "kore-context": () => import("./components/kore-context.vue"),
    "kore-modal": () => import("./components/kore-modal.vue"),
    "kore-chat": () => import("./components/kore-chat.vue"),
    "terms-of-use-modal": () => import("./components/terms-of-use-modal.vue"),
    WebSocketNotifications: () => import("./components/notifications.vue"),
    GlobalHelpDialog: () => import("./components/GlobalHelpDialog.vue"),
  },
  methods: {
    ...mapActions(['getUserData']),
    doColapse: function () {
      this.colapse = !this.colapse;
      window.localStorage.setItem("teros.colapse", this.colapse);
    },
    doCancel: function () {
      this.alert = false;
    },
    alertConfirm: function () {
      this.alert.cb();
      this.alert = false;
    },
    removeTab: function (record) {
      var removedIdx = -1;
      remove(this.openedTabs, (t, i) => {
        var remove = t.path == record.path;
        removedIdx = remove ? i : removedIdx;
        return remove;
      });
      this.openedTabs = [...this.openedTabs];
      if (removedIdx === 0 && this.openedTabs[0]) {
        this.$router.push(this.openedTabs[0].path);
      } else if (removedIdx > 0 && this.openedTabs[removedIdx - 1]) {
        this.$router.push(this.openedTabs[removedIdx - 1].path);
      } else {
        this.$router.push({ name: "homepage" });
      }
    },
    addLoadingProcess: function (processName) {
      this.loadingProcess.push(processName);
    },
    removeLoadingProcess: function (processName) {
      const index = this.loadingProcess.indexOf(processName);
      this.loadingProcess.splice(index, 1);
    },
    collapseMenu() {
      const targetUsers = [UserTypeEnum.GERENCIAL_CLIENTE, UserTypeEnum.CLIENTE_CONSULTOR];
      if((this.clientId == 0 || this.clientId == null) && targetUsers.includes(this.$store.getters.getUserType)) {        
        this.colapse = true;
        window.localStorage.setItem("teros.colapse", this.colapse);
      }
    }
  },
  created: function () {
    setRoot(this.$root);

    this.$root.$on("showContext", (args) => {
      this.context = args;
    });

    this.$root.$on("alert", (args) => {
      this.alert = args;
    });

    this.$root.$on("addLoadingProcess", this.addLoadingProcess);
    this.$root.$on("removeLoadingProcess", this.removeLoadingProcess);

    document.title = process.env.VUE_APP_TITLE || 'Carregando Teros';
    this.collapseMenu();
  },
  computed: {
    ...mapGetters(['clientId', 'jwtToken', 'user']),
    currentTab: function () {
      return this.$route;
    },
    me: function () {
      if (this.$store.state.isAuthed) {
        if (this.$store.state.isAuthed.data.exp > new Date().getTime() / 1000) {
          return this.$store.state.isAuthed.data.nome;
        } else {
          return false;
        }
      } else {
        return "Error";
      }
    },
    authed: function () {
      return this.$store.getters.jwtData;
    },
    openChats: function () {
      return this.chats;
    },
    resourceMe: function () {
      return this.apiResource(`v1/authorization/me`)
    },
    showLoading: function () {
      return this.loadingProcess.length > 0;
    }
  },
  data: function () {
    console.log(window.localStorage.getItem("teros.colapse") === "true");
    return {
      colapse: window.localStorage.getItem("teros.colapse") === "true",
      version: false,
      context: false,
      alert: false,
      loadingProcess: [],
    };
  },
  watch: {
    clientId: function (newVal, oldVal) {
      const targetUsers = [UserTypeEnum.GERENCIAL_CLIENTE, UserTypeEnum.CLIENTE_CONSULTOR];
      const userType = this.$store.getters.getUserType;
      
      if (targetUsers.includes(userType)) {
        if (newVal && !oldVal) {
           this.colapse = false;
           window.localStorage.setItem("teros.colapse", this.colapse);
        } else if (!newVal) {
           this.colapse = true;
           window.localStorage.setItem("teros.colapse", this.colapse);
        }
      }

      if (newVal != oldVal) {
        const processName = 'getUserData';
        this.addLoadingProcess(processName);
        this.getUserData(true).then((response) => {
          const { parentPage } = this.$route.meta || {};

          if (response && !response.error && parentPage) {
            this.$router.push({ name: parentPage });
          }

          this.removeLoadingProcess(processName);
        });
      }
    },
    "user.tipo_usuario": function (tipo) {
      switch (tipo) {
        case UserTypeEnum.ADMINISTRADOR:
        case UserTypeEnum.CONSULTOR:
        case UserTypeEnum.CLIENTE_ADMINISTRADOR:
        case UserTypeEnum.CLIENTE_CONSULTOR:
          this.$vuetify.theme.themes.light["table-header"] = "#BEDEFC";
          this.$vuetify.theme.themes.light["table-header-highlight"] = "#CEE7E7";
          break;        
        case UserTypeEnum.GERENCIAL_CLIENTE:
        case UserTypeEnum.COLABORADOR:
          this.$vuetify.theme.themes.light["table-header"] = "#CEE7E7";
          this.$vuetify.theme.themes.light["table-header-highlight"] = "#BEDEFC";
          break;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/scss/_vuetify.scss";
</style>


<style scoped lang="scss">
.tab-ativa {
  background-color: #f4f4f4 !important;
}

.openedTabs {
  position: relative;
  margin-top: -28px;
  z-index: 4;
}

body {
  overflow: hidden !important;
}

.main-body {
  margin-left: 255px;
  -webkit-transition: width 0.3s ease-in-out, margin-left 0.3s ease-in-out;
  transition: width 0.3s ease-in-out, margin-left 0.3s ease-in-out;
}

.side-colapse {
  margin-left: 57px;
  -webkit-transition: width 0.3s ease-in-out, margin-left 0.3s ease-in-out;
  transition: width 0.3s ease-in-out, margin-left 0.3s ease-in-out;
}

.md-flex {

  /* width */
  &::-webkit-scrollbar {
    width: 15px;
    height: 15px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #dedede;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #becdd9;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #84c2ef;
  }
}

.route-container {
  padding-left: 20px;
  padding-top: 15px;
  padding-right: 20px;
  height: calc(100vh - 95px);
  overflow-y: auto;
  overflow-x: auto;
  background: #f4f4f4;
  position: relative;
}

.footer {
  width: 100vw;
  border-top: silver 1px solid;
  background: white;
  position: fixed;
  left: 0px;
  bottom: 0px;
  padding: 5px;
  padding-right: 20px;
  box-sizing: border-box;
  font-size: 12px;
}

.version {
  position: fixed;
  right: 0px;
  top: 0px;
  font-size: 11px;
  padding: 6px;
  z-index: 999;
  color: white;
}
</style>